import React, { createContext, ReactNode, useContext, useEffect, useMemo, useState } from 'react';

import { useSettings } from '../hooks/useSettings';
import { getWidthLeftHeader } from '../store/slices/gantSlice';

type WidthLeftHeaderContextType = {
    widthLeftHeader?: number;
    setWidthLeftHeader: (value: number) => void;
};

const WidthLeftColumnContext = createContext<WidthLeftHeaderContextType | undefined>(undefined);

export const WidthLeftHeaderProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { userSettingsInitialRef } = useSettings();
    const [widthLeftHeaderState, setWidthLeftHeader] = useState<number>(getWidthLeftHeader(window.innerWidth));

    useEffect(() => {
        if (userSettingsInitialRef.current.projectsTreePanelWidth) {
            setWidthLeftHeader(userSettingsInitialRef.current.projectsTreePanelWidth);
        }
    }, [userSettingsInitialRef.current.projectsTreePanelWidth]);

    const contextValue = useMemo(
        () => ({
            widthLeftHeader: widthLeftHeaderState,
            setWidthLeftHeader,
        }),
        [widthLeftHeaderState],
    );

    return <WidthLeftColumnContext.Provider value={contextValue}>{children}</WidthLeftColumnContext.Provider>;
};

export const useWidthLeftHeaderContext = () => {
    const context = useContext(WidthLeftColumnContext);
    if (!context) {
        throw new Error('useWidthLeftHeaderContext must be used within a WidthLeftHeaderProvider');
    }
    return context;
};
